import React from 'react';
import { Link } from 'react-router-dom';

const SubscriptionCancel: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-orange-50 dark:from-gray-900 dark:via-gray-800 dark:to-red-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white/80 dark:bg-gray-800/80 backdrop-blur-md rounded-3xl shadow-2xl border border-white/30 dark:border-gray-700/30 p-8 text-center">
        {/* Cancel Icon */}
        <div className="w-20 h-20 bg-orange-100 dark:bg-orange-900 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-orange-600 dark:text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>

        {/* Cancel Message */}
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Subscription Canceled
        </h1>

        <p className="text-lg text-gray-600 dark:text-gray-300 mb-6">
          Your subscription process was canceled. No charges have been made to your account.
        </p>

        {/* Information */}
        <div className="bg-gray-50 dark:bg-gray-700/50 rounded-2xl p-4 mb-6">
          <h3 className="font-semibold text-gray-900 dark:text-white mb-2">What happens next?</h3>
          <div className="text-sm text-gray-600 dark:text-gray-300 text-left space-y-2">
            <p>• No payment was processed</p>
            <p>• Your account remains unchanged</p>
            <p>• You can subscribe anytime</p>
          </div>
        </div>

        {/* Features Reminder */}
        <div className="text-left mb-6">
          <h3 className="font-semibold text-gray-900 dark:text-white mb-3 text-center">With Svarra Complete you get:</h3>
          <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-300">
            <li className="flex items-center">
              <svg className="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Up to 5 AI agents
            </li>
            <li className="flex items-center">
              <svg className="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Unlimited conversations
            </li>
            <li className="flex items-center">
              <svg className="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Appointment booking & calendar sync
            </li>
            <li className="flex items-center">
              <svg className="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Analytics & reporting
            </li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <Link
            to="/#pricing"
            className="w-full block bg-gradient-to-r from-primary-500 to-secondary-500 hover:from-primary-600 hover:to-secondary-600 text-white py-3 px-6 rounded-2xl font-medium transition-all duration-300 hover:shadow-lg hover:scale-105"
          >
            Try Again
          </Link>
          
          <Link
            to="/dashboard"
            className="w-full block bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 py-3 px-6 rounded-2xl font-medium transition-all duration-300"
          >
            Back to Dashboard
          </Link>
        </div>

        {/* Support Link */}
        <div className="mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Need help? <Link to="/contact" className="text-primary-600 dark:text-primary-400 hover:underline">Contact support</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel;